import React, { useState } from 'react';
import styled from 'styled-components';
import Surface from '../components/Surface';
import { Heading, Body, Label, Accent } from '../components/Typography';
import { ButtonNative } from '../components/Button';

const PageWrapper = styled(Surface).attrs({ tone: 'base' })`
  padding: 4rem 2rem;

  @media (max-width: 768px) {
    padding: 2.5rem 1.5rem;
  }
`;

const Inner = styled.div`
  max-width: 640px;
  margin: 0 auto;
`;

const PageLabel = styled(Label)`
  display: block;
  color: #a0412d;
  margin-bottom: 0.75rem;
`;

const PageTitle = styled(Heading)`
  font-size: clamp(2rem, 4vw, 2.75rem);
  font-weight: 800;
  margin-bottom: 0.75rem;
`;

const AgencyCard = styled(Surface).attrs({ tone: 'accent' })`
  padding: 1.5rem;
  border-radius: 1.25rem;
  margin-bottom: 2.5rem;
`;

const AgencyText = styled(Body)`
  color: #38312d;
  font-size: 0.9375rem;

  a {
    color: #721f0f;
    font-weight: 600;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  strong {
    color: #38312d;
  }
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
`;

const FieldLabel = styled.label`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 0.875rem;
  font-weight: 600;
  color: #38312d;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
`;

const Input = styled.input`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 1rem;
  color: #38312d;
  background-color: #ece0d9;
  border: none;
  border-bottom: 2px solid transparent;
  border-radius: 0.5rem;
  padding: 0.75rem 1rem;
  width: 100%;
  transition: border-color 0.2s ease, background-color 0.2s ease;
  outline: none;

  &:focus {
    border-bottom-color: #a0412d;
    background-color: #fff8f5;
  }

  &::placeholder {
    color: #bbb0aa;
  }
`;

const Textarea = styled.textarea`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 1rem;
  color: #38312d;
  background-color: #ece0d9;
  border: none;
  border-bottom: 2px solid transparent;
  border-radius: 0.5rem;
  padding: 0.75rem 1rem;
  width: 100%;
  min-height: 140px;
  resize: vertical;
  transition: border-color 0.2s ease, background-color 0.2s ease;
  outline: none;

  &:focus {
    border-bottom-color: #a0412d;
    background-color: #fff8f5;
  }

  &::placeholder {
    color: #bbb0aa;
  }
`;

const Contact = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { name, email, message } = formData;
    const body = `Name: ${name}\r\nEmail: ${email}\r\nMessage: ${message}`;
    window.location.href = `mailto:liz@lbfactors.nz?subject=${encodeURIComponent('Enquiry regarding Sari Angus')}&body=${encodeURIComponent(body)}`;
  };

  return (
    <PageWrapper>
      <Inner>
        <PageLabel>Get in Touch</PageLabel>
        <PageTitle>Contact <Accent>Us.</Accent></PageTitle>

        <AgencyCard>
          <AgencyText>
            Sari is represented by <strong>LBF Actors</strong>. Reach her agent
            directly at <a href="mailto:liz@lbfactors.nz">liz@lbfactors.nz</a> or
            call <a href="tel:092158296">09 215 8296</a>, or use the form below.
          </AgencyText>
        </AgencyCard>

        <Form onSubmit={handleSubmit}>
          <FieldLabel>
            Your name
            <Input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Jane Smith"
              required
            />
          </FieldLabel>
          <FieldLabel>
            Email address
            <Input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="jane@example.com"
              required
            />
          </FieldLabel>
          <FieldLabel>
            Message
            <Textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder="Tell us about the project..."
              required
            />
          </FieldLabel>
          <div>
            <ButtonNative type="submit">Send Message</ButtonNative>
          </div>
        </Form>
      </Inner>
    </PageWrapper>
  );
};

export default Contact;
